var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_407)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5742 9.37891C25.4766 9.14844 25.25 9 25 9C24.75 9 24.5234 9.14844 24.4258 9.37891L22.7031 13.3984C22.5703 13.7109 22.5 14.043 22.5 14.3828V17.3906L16.875 20.6719V19.9375C16.875 19.418 16.457 19 15.9375 19C15.418 19 15 19.418 15 19.9375V22.125V23.375V24.3125C15 24.832 15.418 25.25 15.9375 25.25C16.457 25.25 16.875 24.832 16.875 24.3125V24H22.5V25.2773L20.2148 27.2812C20.0781 27.3984 20 27.5703 20 27.75V28.375C20 28.7188 20.2812 29 20.625 29H24.375V26.5C24.375 26.1562 24.6562 25.875 25 25.875C25.3438 25.875 25.625 26.1562 25.625 26.5V29H29.375C29.7188 29 30 28.7188 30 28.375V27.75C30 27.5703 29.9219 27.3984 29.7852 27.2812L27.5 25.2773V24H33.125V24.3125C33.125 24.832 33.543 25.25 34.0625 25.25C34.582 25.25 35 24.832 35 24.3125V23.375V22.125V19.9375C35 19.418 34.582 19 34.0625 19C33.543 19 33.125 19.418 33.125 19.9375V20.6719L27.5 17.3906V14.3828C27.5 14.043 27.4297 13.7109 27.2969 13.3984L25.5742 9.37891Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_407",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_407"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJet);
export default __webpack_public_path__ + "static/media/jet.3691a00776dc7cfc7bce271d4d016582.svg";
export { ForwardRef as ReactComponent };